export function schema_deux_points(prevColumnNames) {
	return {
		title: "Paramètres",
		type: "object",
		properties: {
			column: {
				title: "Colonne",
				type: "string",
				options: {
					inputAttributes: {
						class: "form-control dropdown-colonne",
					},
				},
			},
			separator: {
				type: "string",
				title: "Séparateur",
				default: ".",
			},
			prefix: {
				type: "string",
				title: "Préfixe des noms de colonne",
			},
		},
	};
}
